var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33329 5.66667V4.33333C9.33329 2.49239 7.84089 1 5.99996 1C4.15901 1 2.66663 2.49239 2.66663 4.33333V5.66667M5.99996 8.66667V10M3.86663 13H8.13329C9.25343 13 9.81343 13 10.2413 12.782C10.6176 12.5903 10.9236 12.2843 11.1153 11.908C11.3333 11.4801 11.3333 10.9201 11.3333 9.8V8.86667C11.3333 7.74653 11.3333 7.18653 11.1153 6.75867C10.9236 6.38233 10.6176 6.0764 10.2413 5.88467C9.81343 5.66667 9.25343 5.66667 8.13329 5.66667H3.86663C2.74652 5.66667 2.18647 5.66667 1.75865 5.88467C1.38232 6.0764 1.07636 6.38233 0.884613 6.75867C0.666626 7.18653 0.666626 7.74653 0.666626 8.86667V9.8C0.666626 10.9201 0.666626 11.4801 0.884613 11.908C1.07636 12.2843 1.38232 12.5903 1.75865 12.782C2.18647 13 2.74652 13 3.86663 13Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.659895e3255ae8c627e8fca12c5ca006.svg";
export { ForwardRef as ReactComponent };